import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APCourse } from '../../../global/builders/ap_course_builder';
import { APGenericSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APPlannedCourse } from '../../../global/builders/ap_planned_course_builder';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { IAPPlannedCourseDataSource } from '../../../global/datasources/ap_planned_course_datasource';
import { IAPProgramSlotDatasource } from '../../../global/datasources/ap_program_slot_datasource';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APProgramSlotServant } from '../../../global/servants/ap_program_slot_servant';
import {
  APDegreeMapQuery,
  ILargeCourseGroupSearchResults
} from '../../components/degree_map/queries/ap_degree_map_query';
import { APTermsQuery } from '../../queries/ap_terms_query';
import { LargeCourseGroupModel } from './models/large_course_group_model';
import { LargeCourseGroupSearchResultsQuery } from './queries/large_course_group_search_results_query';

interface IParentCourse {
  plannedCourse: any;
  programSlot: any;
}
export class LargeCourseGroup {
  private queryString: string;
  private termId = INVALID_ID;
  private courseGroupValue = '';
  private filteredSlots: APGenericSlot[];
  private coursePlaceholderSelectedCourseRemoved: () => void = () => ({});
  private totalCourses: number = 100;
  private showLoading: boolean = false;
  private DEFAULT_PAGINATION_LIMIT = 100;
  private invalidSearchBoxMessage: string = '';
  private hasOneTimeDataFetched: boolean = false;
  private window: any;
  private closeBound: any;
  private isWildCard: boolean = false;
  private isInSwapMode = false;
  private isSmartCatalogEnabled = false;
  private smartCatTitle = '';
  private parentCourse: IParentCourse = {
    plannedCourse: {},
    programSlot: {}
  };
  private pagination = {
    offset: 0,
    limit: this.DEFAULT_PAGINATION_LIMIT
  };

  private statePrefix: string;
  constructor(
    private $state: any,
    private $rootScope: ng.IRootScopeService,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngLargeCourseGroupModel: LargeCourseGroupModel,
    private ngLargeCourseGroupSearchResultsQuery: LargeCourseGroupSearchResultsQuery,
    private fetchLargeCourseGroupCommand: ICommand,
    private smoothScroll: any,
    private $window: any,
    private appConfigModel: any,
    private $timeout: ng.ITimeoutService,
    private routerHelper: RouterHelper,
    private clearLargeCourseGroupSearchResultCommand: ICommand,
    private ngAPProgramSlotDatasource: IAPProgramSlotDatasource,
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    private setSelectedPlannerResourceTabCommand: ICommand
  ) {
    this.queryString = '';
    this.closeBound = this.close.bind(this);
  }

  goBack() {
    this.$state.go('^.default');
  }
  get hasCoursePlanned() {
    const slotId = _4.toNumber(_4.get(this.$state, 'params.slotId', INVALID_ID));
    const plannedCourses = this.ngAPPlannedCoursesDatasource.values();
    const plannedCourseInSlot = _4.find(
      plannedCourses,
      (plannedCourse: APPlannedCourse) => plannedCourse.program_slot === slotId
    );
    this.parentCourse['plannedCourse'] = plannedCourseInSlot || {};
    return !_4.isEmpty(plannedCourseInSlot);
  }

  get getSlotCourseGroupValue() {
    let courseGroupValue = '';
    const slot = this.ngAPProgramSlotDatasource.get(_4.get(this.$state, 'params.slotId', INVALID_ID));
    this.parentCourse['programSlot'] = slot || {};
    if (slot) {
      courseGroupValue = slot.course_group;
    }
    return courseGroupValue;
  }

  smartSearchCatTitle() {
    const title = _4.get(this.parentCourse, 'programSlot.desc', '');
    return this.isWildCard ? title : `${title} Filters and Results`;
  }
  $onInit() {
    this.courseGroupValue = this.getSlotCourseGroupValue;
    this.termId = _4.get(this.$state, 'params.termId', INVALID_ID);
    this.isInSwapMode = this.hasCoursePlanned;
    this.isWildCard = this.ngLargeCourseGroupModel.read().selectedSlot.type === 'WILDCARD';
    this.isSmartCatalogEnabled = this.appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
    this.smartCatTitle = this.smartSearchCatTitle();

    const largeCourseGroupQueryResult = this.ngLargeCourseGroupSearchResultsQuery.result;
    if (largeCourseGroupQueryResult.highlightedTerm !== INVALID_ID) {
      this.smoothScroll.scrollTo(`term-${largeCourseGroupQueryResult.highlightedTerm}`, 30);
    }

    // the selectedSlot will always exist in this component on model ngLargeCourseGroupModel
    if (APProgramSlotServant.isCourseGroupProgramSlot(this.ngLargeCourseGroupModel.read().selectedSlot.programSlot)) {
      this.onValueChanged();
    }

    this.ngComponentCommunicatorService.subscribe('CLOSE_LARGE_COURSE_GROUP_PANEL', this.closeBound);
    this.coursePlaceholderSelectedCourseRemoved = this.$rootScope.$on(
      'COURSE-PLACEHOLDER-SELECTED-COURSE-REMOVED',
      (event: ng.IAngularEvent, course: APCourse) => this.$state.go('^.default')
    );
  }

  searchCourseButton(event: any) {
    const target = event.target || event.__target || event.srcElement;
    const searchComponent = target.parentElement;
    const isInputValid = searchComponent.validate();
    this.invalidSearchBoxMessage = searchComponent.$.input.validationMessage;
    if (!isInputValid) {
      return;
    }
    this.searchCourseInsideCourseGroup();
  }

  fetchCourses() {
    this.showLoading = true;
    this.fetchLargeCourseGroupCommand(
      _4.get(this.ngLargeCourseGroupModel.read(), 'selectedSlot.programSlot.id', null),
      this.pagination.limit,
      this.pagination.offset,
      this.queryString
    ).then(() => {
      this.hasOneTimeDataFetched = true;
      this.showLoading = false;
    });
  }

  onValueChanged($event?: ng.IAngularEvent) {
    this.queryString = $event ? _4.get($event, 'detail.value', '') : '';
    if (!_4.isEmpty(_4.trim(this.queryString)) && _4.lt(this.queryString.length, 3)) {
      this.clearLargeCourseGroupSearchResultCommand();
      return;
    }
    this.$timeout(() => {
      this.clearLargeCourseGroupSearchResultCommand();
      this.searchCourseInsideCourseGroup();
    }, 300);
  }

  searchCourseInsideCourseGroup() {
    if (_4.isEmpty(_4.trim(this.queryString))) {
      this.pagination.limit = this.DEFAULT_PAGINATION_LIMIT;
      this.pagination.offset = 0;
    } else {
      this.clearLargeCourseGroupSearchResultCommand();
      this.pagination.limit = this.DEFAULT_PAGINATION_LIMIT;
      this.pagination.offset = 0;
    }
    this.fetchCourses();
  }

  showingCoursesLimitText() {
    return `Showing ${this.pagination.offset + 1} - ${Math.min(
      this.pagination.offset + this.pagination.limit,
      this.ngLargeCourseGroupSearchResultsQuery.result.totalCourses
    )} of ${this.ngLargeCourseGroupSearchResultsQuery.result.totalCourses} courses.`;
  }
  onNext() {
    this.pagination.offset = this.pagination.offset + this.pagination.limit;
    this.fetchCourses();
  }
  onPrevious() {
    this.pagination.offset = this.pagination.offset - this.pagination.limit;
  }

  $onDestroy() {
    if (_4.isFunction(this.coursePlaceholderSelectedCourseRemoved)) {
      this.coursePlaceholderSelectedCourseRemoved();
    }
    this.ngComponentCommunicatorService.release('CLOSE_LARGE_COURSE_GROUP_PANEL', this.closeBound);
  }

  close() {
    if (_4.includes(this.$state.current.name, 'coursegroup')) {
      this.routerHelper.findStateAndGo('^.default');
      this.setSelectedPlannerResourceTabCommand('MAP');
    }
  }
}

angular.module('capability-ng-academic-planner').component('largeCourseGroup', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/large_course_group/large_course_group.html',
  bindings: {
    isEditable: '<'
  },
  controller: LargeCourseGroup
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/large_course_group/large_course_group.ts